import { SvgIcon } from "@mui/material";

export default function FuseIcon({ sx }) {
  return (
    <SvgIcon sx={{ width: 24, height: 24, ...sx }}>
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="400" height="400" version="1.1" viewBox="0 0 400 400">
        <g>
          <polygon fill="#fff" points="90 26.8 53.7 372.9 165.7 372.9 202.1 26.8 90 26.8"/>
          <polygon fill="#fff" points="212.4 166.3 227.1 26.8 205.4 232.8 307.5 232.8 314.5 166.3 212.4 166.3"/>
        </g>
        <polygon fill="#4fbc86" points="345.5 94.6 227.1 26.8 212.7 161.8 345.5 94.6"/>
      </svg>
    </SvgIcon>
  )
}
